document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') {
    return;
  }

  var galleries = document.querySelectorAll('.product-gallery-slider');

  galleries.forEach(function (gallery) {
    var thumbsEl = gallery.querySelector('.product-gallery-thumbs');
    var mainEl = gallery.querySelector('.product-gallery-main');

    if (!thumbsEl || !mainEl) {
      return;
    }

    // Thumbnail strip: horizontal (bottom) on mobile, vertical (left) on
    // tablet/desktop. A draggable scrollbar signals that more thumbnails exist.
    var thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      direction: 'horizontal',
      scrollbar: {
        el: thumbsEl.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      breakpoints: {
        992: {
          direction: 'vertical',
        },
      },
    });

    // Show the "more thumbnails" fade only while the strip overflows AND isn't
    // scrolled to the end. `isLocked` = everything fits; `isEnd` = at the end.
    var updateFade = function () {
      var show = !thumbsSwiper.isLocked && !thumbsSwiper.isEnd;
      thumbsEl.classList.toggle('show-thumb-fade', show);
    };
    thumbsSwiper.on(
      'lock unlock resize breakpoint setTranslate reachEnd fromEdge toEdge transitionEnd',
      updateFade
    );
    updateFade();

    // Main image slider, linked to the thumbnails.
    new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  });
});
